import { Box, styled } from '@mui/material';

export const SearchBoxContainer = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  width: '300px',
  height: '90%',
}));

export const UsersButtonsRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
}));
